export default __webpack_public_path__ + "static/media/Dinheiro.ccb7fefc.svg";